import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { LegalEntitiesApiClient, LegalEntitiesApi } from '@sg/api/legal-entities-api';
import { validateArrayType } from './utils/validate-array';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    AccountById: {
      entity: LegalEntitiesApi.AccountDto | LegalEntitiesApi.MinorAccountDto | LegalEntitiesApi.SubAccountDto;
      query: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
    };
  }
}

export class AccountsByIdToEntityFetcherLink implements SgEntityFetchAdapter<'AccountById'> {
  readonly key: 'AccountById' = 'AccountById';
  readonly metadata: {
    idField: 'accountId';
    labelField: 'accountName';
    queryField?: { field: keyof LegalEntitiesApi.SearchLegalEntitiesAccountRequest; isArray?: boolean };
  } = {
    idField: 'accountId',
    labelField: 'accountName',
    queryField: { field: 'accountNames', isArray: true },
  };

  private readonly legalEntitiesApi: LegalEntitiesApiClient;

  constructor(injector: Injector) {
    this.legalEntitiesApi = injector.get(LegalEntitiesApiClient);
  }

  getEntity(accountIds: string[]) {
    const body: LegalEntitiesApi.SearchLegalEntitiesAccountRequest = { accountIds: validateArrayType(accountIds) };
    return this.legalEntitiesApi
      .legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams({ body, pageNumber: 1 }, { observe: 'body' })
      .pipe(
        map((results) =>
          results.rows
            .map((row) => row.account)
            .filter(
              (
                account
              ): account is
                | LegalEntitiesApi.AccountDto
                | LegalEntitiesApi.MinorAccountDto
                | LegalEntitiesApi.SubAccountDto => account !== undefined
            )
        )
      );
  }

  findEntities(query?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest, pageNumber?: number) {
    const body: LegalEntitiesApi.SearchLegalEntitiesAccountRequest = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.legalEntitiesApi
      .legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1 },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          const accounts = result.rows
            ? result.rows
                .map((row) => row.account)
                .filter(
                  (
                    account
                  ): account is
                    | LegalEntitiesApi.AccountDto
                    | LegalEntitiesApi.MinorAccountDto
                    | LegalEntitiesApi.SubAccountDto => account !== undefined
                )
            : [];

          return {
            data: accounts,
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
